/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TimesheetsRouteImport } from './routes/timesheets'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as OrgRouteRouteImport } from './routes/org/route'
import { Route as ManagerRouteRouteImport } from './routes/manager/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrgIndexRouteImport } from './routes/org/index'
import { Route as ManagerIndexRouteImport } from './routes/manager/index'
import { Route as OrgNotificationsRouteImport } from './routes/org/notifications'
import { Route as OrgImportPeopleRouteImport } from './routes/org/import-people'
import { Route as OrgImportEmployeesRouteImport } from './routes/org/import-employees'
import { Route as OrgImportBulkRouteImport } from './routes/org/import-bulk'
import { Route as OrgImportRouteImport } from './routes/org/import'
import { Route as OrgCronRouteImport } from './routes/org/cron'
import { Route as OrgBambooIntrospectRouteImport } from './routes/org/bamboo-introspect'
import { Route as ManagerTimesheetsRouteImport } from './routes/manager/timesheets'
import { Route as ManagerTeamRouteImport } from './routes/manager/team'
import { Route as OrgUsersIndexRouteImport } from './routes/org/users/index'
import { Route as OrgUsersEmployeeIdRouteImport } from './routes/org/users/$employeeId'
import { Route as ManagerReviewTimesheetIdRouteImport } from './routes/manager/review.$timesheetId'

const TimesheetsRoute = TimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRouteRoute = OrgRouteRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagerRouteRoute = ManagerRouteRouteImport.update({
  id: '/manager',
  path: '/manager',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgIndexRoute = OrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgRouteRoute,
} as any)
const ManagerIndexRoute = ManagerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManagerRouteRoute,
} as any)
const OrgNotificationsRoute = OrgNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgImportPeopleRoute = OrgImportPeopleRouteImport.update({
  id: '/import-people',
  path: '/import-people',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgImportEmployeesRoute = OrgImportEmployeesRouteImport.update({
  id: '/import-employees',
  path: '/import-employees',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgImportBulkRoute = OrgImportBulkRouteImport.update({
  id: '/import-bulk',
  path: '/import-bulk',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgImportRoute = OrgImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgCronRoute = OrgCronRouteImport.update({
  id: '/cron',
  path: '/cron',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgBambooIntrospectRoute = OrgBambooIntrospectRouteImport.update({
  id: '/bamboo-introspect',
  path: '/bamboo-introspect',
  getParentRoute: () => OrgRouteRoute,
} as any)
const ManagerTimesheetsRoute = ManagerTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => ManagerRouteRoute,
} as any)
const ManagerTeamRoute = ManagerTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => ManagerRouteRoute,
} as any)
const OrgUsersIndexRoute = OrgUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgUsersEmployeeIdRoute = OrgUsersEmployeeIdRouteImport.update({
  id: '/users/$employeeId',
  path: '/users/$employeeId',
  getParentRoute: () => OrgRouteRoute,
} as any)
const ManagerReviewTimesheetIdRoute =
  ManagerReviewTimesheetIdRouteImport.update({
    id: '/review/$timesheetId',
    path: '/review/$timesheetId',
    getParentRoute: () => ManagerRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/manager': typeof ManagerRouteRouteWithChildren
  '/org': typeof OrgRouteRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/history': typeof HistoryRoute
  '/timesheets': typeof TimesheetsRoute
  '/manager/team': typeof ManagerTeamRoute
  '/manager/timesheets': typeof ManagerTimesheetsRoute
  '/org/bamboo-introspect': typeof OrgBambooIntrospectRoute
  '/org/cron': typeof OrgCronRoute
  '/org/import': typeof OrgImportRoute
  '/org/import-bulk': typeof OrgImportBulkRoute
  '/org/import-employees': typeof OrgImportEmployeesRoute
  '/org/import-people': typeof OrgImportPeopleRoute
  '/org/notifications': typeof OrgNotificationsRoute
  '/manager/': typeof ManagerIndexRoute
  '/org/': typeof OrgIndexRoute
  '/manager/review/$timesheetId': typeof ManagerReviewTimesheetIdRoute
  '/org/users/$employeeId': typeof OrgUsersEmployeeIdRoute
  '/org/users/': typeof OrgUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/history': typeof HistoryRoute
  '/timesheets': typeof TimesheetsRoute
  '/manager/team': typeof ManagerTeamRoute
  '/manager/timesheets': typeof ManagerTimesheetsRoute
  '/org/bamboo-introspect': typeof OrgBambooIntrospectRoute
  '/org/cron': typeof OrgCronRoute
  '/org/import': typeof OrgImportRoute
  '/org/import-bulk': typeof OrgImportBulkRoute
  '/org/import-employees': typeof OrgImportEmployeesRoute
  '/org/import-people': typeof OrgImportPeopleRoute
  '/org/notifications': typeof OrgNotificationsRoute
  '/manager': typeof ManagerIndexRoute
  '/org': typeof OrgIndexRoute
  '/manager/review/$timesheetId': typeof ManagerReviewTimesheetIdRoute
  '/org/users/$employeeId': typeof OrgUsersEmployeeIdRoute
  '/org/users': typeof OrgUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/manager': typeof ManagerRouteRouteWithChildren
  '/org': typeof OrgRouteRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/history': typeof HistoryRoute
  '/timesheets': typeof TimesheetsRoute
  '/manager/team': typeof ManagerTeamRoute
  '/manager/timesheets': typeof ManagerTimesheetsRoute
  '/org/bamboo-introspect': typeof OrgBambooIntrospectRoute
  '/org/cron': typeof OrgCronRoute
  '/org/import': typeof OrgImportRoute
  '/org/import-bulk': typeof OrgImportBulkRoute
  '/org/import-employees': typeof OrgImportEmployeesRoute
  '/org/import-people': typeof OrgImportPeopleRoute
  '/org/notifications': typeof OrgNotificationsRoute
  '/manager/': typeof ManagerIndexRoute
  '/org/': typeof OrgIndexRoute
  '/manager/review/$timesheetId': typeof ManagerReviewTimesheetIdRoute
  '/org/users/$employeeId': typeof OrgUsersEmployeeIdRoute
  '/org/users/': typeof OrgUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/manager'
    | '/org'
    | '/calendar'
    | '/history'
    | '/timesheets'
    | '/manager/team'
    | '/manager/timesheets'
    | '/org/bamboo-introspect'
    | '/org/cron'
    | '/org/import'
    | '/org/import-bulk'
    | '/org/import-employees'
    | '/org/import-people'
    | '/org/notifications'
    | '/manager/'
    | '/org/'
    | '/manager/review/$timesheetId'
    | '/org/users/$employeeId'
    | '/org/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar'
    | '/history'
    | '/timesheets'
    | '/manager/team'
    | '/manager/timesheets'
    | '/org/bamboo-introspect'
    | '/org/cron'
    | '/org/import'
    | '/org/import-bulk'
    | '/org/import-employees'
    | '/org/import-people'
    | '/org/notifications'
    | '/manager'
    | '/org'
    | '/manager/review/$timesheetId'
    | '/org/users/$employeeId'
    | '/org/users'
  id:
    | '__root__'
    | '/'
    | '/manager'
    | '/org'
    | '/calendar'
    | '/history'
    | '/timesheets'
    | '/manager/team'
    | '/manager/timesheets'
    | '/org/bamboo-introspect'
    | '/org/cron'
    | '/org/import'
    | '/org/import-bulk'
    | '/org/import-employees'
    | '/org/import-people'
    | '/org/notifications'
    | '/manager/'
    | '/org/'
    | '/manager/review/$timesheetId'
    | '/org/users/$employeeId'
    | '/org/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ManagerRouteRoute: typeof ManagerRouteRouteWithChildren
  OrgRouteRoute: typeof OrgRouteRouteWithChildren
  CalendarRoute: typeof CalendarRoute
  HistoryRoute: typeof HistoryRoute
  TimesheetsRoute: typeof TimesheetsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/timesheets': {
      id: '/timesheets'
      path: '/timesheets'
      fullPath: '/timesheets'
      preLoaderRoute: typeof TimesheetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org': {
      id: '/org'
      path: '/org'
      fullPath: '/org'
      preLoaderRoute: typeof OrgRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manager': {
      id: '/manager'
      path: '/manager'
      fullPath: '/manager'
      preLoaderRoute: typeof ManagerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/': {
      id: '/org/'
      path: '/'
      fullPath: '/org/'
      preLoaderRoute: typeof OrgIndexRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/manager/': {
      id: '/manager/'
      path: '/'
      fullPath: '/manager/'
      preLoaderRoute: typeof ManagerIndexRouteImport
      parentRoute: typeof ManagerRouteRoute
    }
    '/org/notifications': {
      id: '/org/notifications'
      path: '/notifications'
      fullPath: '/org/notifications'
      preLoaderRoute: typeof OrgNotificationsRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/org/import-people': {
      id: '/org/import-people'
      path: '/import-people'
      fullPath: '/org/import-people'
      preLoaderRoute: typeof OrgImportPeopleRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/org/import-employees': {
      id: '/org/import-employees'
      path: '/import-employees'
      fullPath: '/org/import-employees'
      preLoaderRoute: typeof OrgImportEmployeesRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/org/import-bulk': {
      id: '/org/import-bulk'
      path: '/import-bulk'
      fullPath: '/org/import-bulk'
      preLoaderRoute: typeof OrgImportBulkRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/org/import': {
      id: '/org/import'
      path: '/import'
      fullPath: '/org/import'
      preLoaderRoute: typeof OrgImportRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/org/cron': {
      id: '/org/cron'
      path: '/cron'
      fullPath: '/org/cron'
      preLoaderRoute: typeof OrgCronRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/org/bamboo-introspect': {
      id: '/org/bamboo-introspect'
      path: '/bamboo-introspect'
      fullPath: '/org/bamboo-introspect'
      preLoaderRoute: typeof OrgBambooIntrospectRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/manager/timesheets': {
      id: '/manager/timesheets'
      path: '/timesheets'
      fullPath: '/manager/timesheets'
      preLoaderRoute: typeof ManagerTimesheetsRouteImport
      parentRoute: typeof ManagerRouteRoute
    }
    '/manager/team': {
      id: '/manager/team'
      path: '/team'
      fullPath: '/manager/team'
      preLoaderRoute: typeof ManagerTeamRouteImport
      parentRoute: typeof ManagerRouteRoute
    }
    '/org/users/': {
      id: '/org/users/'
      path: '/users'
      fullPath: '/org/users/'
      preLoaderRoute: typeof OrgUsersIndexRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/org/users/$employeeId': {
      id: '/org/users/$employeeId'
      path: '/users/$employeeId'
      fullPath: '/org/users/$employeeId'
      preLoaderRoute: typeof OrgUsersEmployeeIdRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/manager/review/$timesheetId': {
      id: '/manager/review/$timesheetId'
      path: '/review/$timesheetId'
      fullPath: '/manager/review/$timesheetId'
      preLoaderRoute: typeof ManagerReviewTimesheetIdRouteImport
      parentRoute: typeof ManagerRouteRoute
    }
  }
}

interface ManagerRouteRouteChildren {
  ManagerTeamRoute: typeof ManagerTeamRoute
  ManagerTimesheetsRoute: typeof ManagerTimesheetsRoute
  ManagerIndexRoute: typeof ManagerIndexRoute
  ManagerReviewTimesheetIdRoute: typeof ManagerReviewTimesheetIdRoute
}

const ManagerRouteRouteChildren: ManagerRouteRouteChildren = {
  ManagerTeamRoute: ManagerTeamRoute,
  ManagerTimesheetsRoute: ManagerTimesheetsRoute,
  ManagerIndexRoute: ManagerIndexRoute,
  ManagerReviewTimesheetIdRoute: ManagerReviewTimesheetIdRoute,
}

const ManagerRouteRouteWithChildren = ManagerRouteRoute._addFileChildren(
  ManagerRouteRouteChildren,
)

interface OrgRouteRouteChildren {
  OrgBambooIntrospectRoute: typeof OrgBambooIntrospectRoute
  OrgCronRoute: typeof OrgCronRoute
  OrgImportRoute: typeof OrgImportRoute
  OrgImportBulkRoute: typeof OrgImportBulkRoute
  OrgImportEmployeesRoute: typeof OrgImportEmployeesRoute
  OrgImportPeopleRoute: typeof OrgImportPeopleRoute
  OrgNotificationsRoute: typeof OrgNotificationsRoute
  OrgIndexRoute: typeof OrgIndexRoute
  OrgUsersEmployeeIdRoute: typeof OrgUsersEmployeeIdRoute
  OrgUsersIndexRoute: typeof OrgUsersIndexRoute
}

const OrgRouteRouteChildren: OrgRouteRouteChildren = {
  OrgBambooIntrospectRoute: OrgBambooIntrospectRoute,
  OrgCronRoute: OrgCronRoute,
  OrgImportRoute: OrgImportRoute,
  OrgImportBulkRoute: OrgImportBulkRoute,
  OrgImportEmployeesRoute: OrgImportEmployeesRoute,
  OrgImportPeopleRoute: OrgImportPeopleRoute,
  OrgNotificationsRoute: OrgNotificationsRoute,
  OrgIndexRoute: OrgIndexRoute,
  OrgUsersEmployeeIdRoute: OrgUsersEmployeeIdRoute,
  OrgUsersIndexRoute: OrgUsersIndexRoute,
}

const OrgRouteRouteWithChildren = OrgRouteRoute._addFileChildren(
  OrgRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ManagerRouteRoute: ManagerRouteRouteWithChildren,
  OrgRouteRoute: OrgRouteRouteWithChildren,
  CalendarRoute: CalendarRoute,
  HistoryRoute: HistoryRoute,
  TimesheetsRoute: TimesheetsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
